import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ManagedUser } from '../models/managed-user.model';
import { UserFormModel } from '../models/user-form.model';
import { UserActions } from './user.actions';

@Injectable({ providedIn: 'root' })
export class UserActionsFacade {
  private readonly _store = inject(Store);

  public loadUsers(page: number): void {
    this._store.dispatch(UserActions.loadUsers({ page }));
  }

  public changeSearch(search: string): void {
    this._store.dispatch(UserActions.changeSearch({ search }));
  }

  public selectUser(userId: number): void {
    this._store.dispatch(UserActions.selectUser({ userId }));
  }

  public startCreate(): void {
    this._store.dispatch(UserActions.startCreate());
  }

  public clearForm(): void {
    this._store.dispatch(UserActions.clearForm());
  }

  public resetState(): void {
    this._store.dispatch(UserActions.resetState());
  }

  public loadCompanies(): void {
    this._store.dispatch(UserActions.loadCompanies());
  }

  public loadCompanyDetail(companyId: number): void {
    this._store.dispatch(UserActions.loadCompanyDetail({ companyId }));
  }

  public loadMultiBuyerEntities(companyId: number): void {
    this._store.dispatch(UserActions.loadMultiBuyerEntities({ companyId }));
  }

  public loadProjectManagers(companyId: number): void {
    this._store.dispatch(UserActions.loadProjectManagers({ companyId }));
  }

  public saveUser(form: UserFormModel): void {
    this._store.dispatch(UserActions.saveUser({ form }));
  }

  public toggleStatus(user: ManagedUser): void {
    this._store.dispatch(UserActions.toggleUserStatus({ user }));
  }

  public loadApiToken(userId: number): void {
    this._store.dispatch(UserActions.loadApiToken({ userId }));
  }

  public clearApiToken(): void {
    this._store.dispatch(UserActions.clearApiToken());
  }
}
